import { ApiMethodDeclaration } from 'retail-front-services/api';

import { TransferDataResponse } from '@utils/types';

type ParamsData = {
    /**
     *  Публичный идентификатор собиралки/разделялки
     */
    publicId: string;
};

/**
 * Получает данные о собиралке/разделялке
 */
export const getTransferData: ApiMethodDeclaration<ParamsData, TransferDataResponse> = (data: ParamsData) => ({
    url: `/get-transfer-data?publicId=${data.publicId}`,
    method: 'GET'
});
